<template>
  <Vfm :show="show" @onclose="handleClose" class="z-1000" :class="[show ? '' : 'none']">
    <div class="h-350 absolute t-0 b-0 l-0 r-0 m-auto bg-color-4 rounded-10 overflow-hidden flex-col pb-20"
      style="width:82.6%;">
      <!-- 头部 -->
      <div class="flex items-center justify-between px-14 py-14 bg-color-linear-12">
        <span class="text-15 font-700 text-color-0">{{ $t("A0295") }}</span><i @click="handleClose"
          class="inline-block h-[max-content] w-[max-content] icon sysicon-new-clean-3 text-color-2 text-15 "></i>
      </div>
      <!-- 内容 -->
      <div class="flex-1 px-20 pt-20 overflow-auto" v-if="list.length">
        <!-- 今日是第几天 -->
        <!-- <div>{{ currentToday }}</div> -->
        <!-- 七天签到 -->
        <ul class="flex flex-wrap mb-10">
          <li class="item h-90 rounded-5 bg-color-2 text-12 py-10 text-center lh-15 relative mb-6" :class="[
            index === 3 || index === 6 ? 'mr-0' : 'mr-6',
            index === 6 ? 'flex-1' : ''
          ]" v-for="(item, index) in list" key="index">
            <div class="h-34 relative text-0 mb-6 flex items-center justify-center">
              <BS style="transform: scale(1.5);" />
              <div class="absolute t-0 l-0 r-0 b-0 flex items-center justify-center" v-show="item.id <= checkInDays">
                  <div class="bg-color-alpha-black-07 w-34 h-34 rounded-34"></div>
                </div>
            </div>
            <div class="font-700" :class="[
              item.id <= checkInDays ? 'text-color-2' : 'text-color-0'
            ]">
              +
              <span class="whitespace-pre">
                {{ formatAmount(Utils.$floatMoney(item.bonus)).completeNumber }}
                <span class="text-color-2">
                  {{
                    formatAmount(Utils.$floatMoney(item.bonus)).trailingZero
                  }}</span>
              </span>
            </div>
            <div class="flex items-center justify-center">
              <span class="" :class="[
                currentToday === item.id
                  ? data.sign
                    ? 'text-color-2'
                    : 'text-color-high-2'
                  : item.id < currentToday
                    ? 'text-color-2'
                    : 'text-color-1'
              ]">{{ currentToday === item.id ? $t("A0303") : item.day }}</span>
            </div>
            <div class="check-in-animate-container" :id="`checkInAnimateContainer-${item.id}`">
              <img src="@images/bonus/star-1.png" alt="" />
              <img src="@images/bonus/star-2.png" alt="" />
              <img src="@images/bonus/star-3.png" alt="" />
              <img src="@images/bonus/star-4.png" alt="" />
              <img src="@images/bonus/star-5.png" alt="" />
            </div>
          </li>
        </ul>
        <button @click="handleCheckIn" :disabled="disabled"
          class="flex items-center min-h-40 justify-center w-full uppercase rounded-5 text-14 font-700 bg-color-high-2 text-color-0">
          {{ $t("A0043") }}
        </button>
        <!-- <div class="mt-10 text-10 text-color-1">
          <p>Conditions:</p>
          <ul class="mt-2 list-disc list-outside ml-12">
            <li>
              Deposit
              <span class="whitespace-pre">{{ $C.UNIT }} 10.00</span>
            </li>
            <li>
              Bet
              <span class="whitespace-pre">{{ $C.UNIT }} 20.00</span>
            </li>
          </ul>
        </div> -->
      </div>
      <Empty v-if="!list.length" />
    </div>
  </Vfm>
  <Vfm :show="showDeposit" @onclose="showDeposit = false" style="z-index: 1000" :style="{ display: showDeposit ? 'block' : 'none' }">
    <div class="absolute b-0 w-full bg-color-4 px-15 pb-20 pt-18 rounded-tl-15 rounded-tr-15">
      <div class="flex items-center justify-between">
        <span class="text-16 font-700">{{ $t("CD0042") }}</span>
        <i class="sysicon-new-clean-3 text-15 text-color-2" @click="showDeposit = false"></i>
      </div>
      <div class="content mt-16 mb-20 text-center text-12 break-all">
        {{ $t("11010") }}
      </div>
      <div class="flex font-700">
        <button class="bg-color-btn-2 text-color-0 flex-1 h-40 rounded-5 mr-10" @click="handleGo">
          {{ $t("CD0043") }}
        </button>
        <button class="bg-color-main text-color-0 flex-1 h-40 rounded-5 mr-10" @click="showDeposit = false">
          {{ $t("A0221") }}
        </button>
      </div>
    </div>
  </Vfm>
</template>
<script setup>
import { ref, computed, getCurrentInstance, watch } from "vue";
import Utils from "@/utils/util.js";
import { apiCheckIn } from "@/api";
import BS from "@/components/BS.vue";
import { useNav } from "@/hooks/useNav.js";
import eventBus from "@/utils/eventBus";

const nav = useNav();

const { proxy } = getCurrentInstance();
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  list: {
    type: Array,
    default: []
  },
  data: {
    type: Object,
    default: {}
  },
  disabled: {
    type: Boolean,
    default: false
  }
});
const showDeposit = ref(false)

watch(
  () => props.show,
  newVal => {
    // console.log(props.list);
  }
);
// 连续签到天数 包括今日
const checkInDays = computed(() => {
  return props.data.sign_in_days + props.data.sign >= 7
    ? props.data.sign
      ? 7
      : 6
    : props.data.sign_in_days + props.data.sign;
});
const emit = defineEmits(["onclose", "onsuccess"]);
function handleClose() {
  emit("onclose");
}
function handleGo() {
  showDeposit.value = false
  handleClose()
  nav('/deposit')
}

// 找出今天是第几天
const currentToday = computed(() => {
  return props.data.sign_in_days + 1 > 7 ? 7 : props.data.sign_in_days + 1;
});
// 提交签到
async function handleCheckIn() {
  //   emit("oncheckin");
  proxy.$Loading.show(); // 显示 loading
  try {
    const { data, code } = await apiCheckIn({
      type: 1 //1签到 2查询
    });
    // console.log(data);
    if (code === 11010) {
      showDeposit.value = true
      return
    }
    const index = props.list.findIndex(v => v.id === currentToday.value)
    if (index > -1) {
      eventBus.emit('ShowCoin', props.list[index].bonus)
    }
    const checkInAnimateEle = document.getElementById(
      `checkInAnimateContainer-${currentToday.value}`
    );
    if (checkInAnimateEle) {
      checkInAnimateEle.classList.add("click");
      // 1秒后移除click类名
      setTimeout(() => {
        checkInAnimateEle.classList.remove("click");
        handleClose();
        emit("onsuccess");
      }, 1000);
    }
  } catch (error) {
  } finally {
    proxy.$Loading.hide(); // 显示 loading
  }
}
/**
 * 格式化金额并分离完整数字和尾部的0
 * @param {number} amount - 要格式化的金额
 * @returns {object} 包含完整数字和尾部0的对象
 */
function formatAmount(amount) {
  // 确保金额为数字并转换为浮点数
  const value = parseFloat(amount);

  // 格式化金额，保留两位小数
  const formattedValue = value.toFixed(2);

  // 分离整数部分和小数部分
  const [integerPart, decimalPart] = formattedValue.split(".");

  // 如果小数部分是 "00"，则将其单独处理
  if (decimalPart === "00") {
    return {
      completeNumber: integerPart,
      trailingZero: ".00"
    };
  }

  // 如果小数部分有非零的部分，则去掉尾部的0
  if (decimalPart.endsWith("0")) {
    return {
      completeNumber: `${integerPart}.${decimalPart.slice(0, -1)}`,
      trailingZero: "0"
    };
  }

  // 正常情况
  return {
    completeNumber: `${integerPart}.${decimalPart}`,
    trailingZero: ""
  };
}
</script>

<style lang="scss" scoped>
.item {
  width: -moz-calc(25% - 4.5px);
  width: calc(25% - 4.5px);
}

.check-in-animate-container {
  height: 100%;
  inset: 0;
  margin: auto;
  position: absolute;
  width: 100%;
}

.check-in-animate-container.click img:first-child {
  -webkit-animation: starMove1-49a297e6 0.8s forwards;
  -moz-animation: starMove1-49a297e6 0.8s forwards;
  -o-animation: starMove1-49a297e6 0.8s forwards;
  animation: starMove1-49a297e6 0.8s forwards;
}

.check-in-animate-container.click img:nth-child(2) {
  -webkit-animation: starMove2-49a297e6 0.8s 50ms forwards;
  -moz-animation: starMove2-49a297e6 0.8s 50ms forwards;
  -o-animation: starMove2-49a297e6 0.8s 50ms forwards;
  animation: starMove2-49a297e6 0.8s 50ms forwards;
}

.check-in-animate-container.click img:nth-child(3) {
  -webkit-animation: starMove3-49a297e6 0.75s 80ms forwards;
  -moz-animation: starMove3-49a297e6 0.75s 80ms forwards;
  -o-animation: starMove3-49a297e6 0.75s 80ms forwards;
  animation: starMove3-49a297e6 0.75s 80ms forwards;
}

.check-in-animate-container.click img:nth-child(4) {
  -webkit-animation: starMove4-49a297e6 0.5s 0.2s forwards;
  -moz-animation: starMove4-49a297e6 0.5s 0.2s forwards;
  -o-animation: starMove4-49a297e6 0.5s 0.2s forwards;
  animation: starMove4-49a297e6 0.5s 0.2s forwards;
}

.check-in-animate-container.click img:nth-child(5) {
  -webkit-animation: starMove5-49a297e6 0.7s 0.12s forwards;
  -moz-animation: starMove5-49a297e6 0.7s 0.12s forwards;
  -o-animation: starMove5-49a297e6 0.7s 0.12s forwards;
  animation: starMove5-49a297e6 0.7s 0.12s forwards;
}

.check-in-animate-container img {
  height: 0;
  inset: 0;
  margin: auto;
  opacity: 1;
  position: absolute;
  width: 0;
}

@-webkit-keyframes starMove1-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -webkit-transform: translate3d(10px, -28px, 0);
    transform: translate3d(10px, -28px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -webkit-transform: translate3d(10px, -28px, 0);
    transform: translate3d(10px, -28px, 0);
    width: 18px;
  }
}

@-moz-keyframes starMove1-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -moz-transform: translate3d(10px, -28px, 0);
    transform: translate3d(10px, -28px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -moz-transform: translate3d(10px, -28px, 0);
    transform: translate3d(10px, -28px, 0);
    width: 18px;
  }
}

@-o-keyframes starMove1-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    transform: translate3d(10px, -28px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    transform: translate3d(10px, -28px, 0);
    width: 18px;
  }
}

@keyframes starMove1-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -webkit-transform: translate3d(10px, -28px, 0);
    -moz-transform: translate3d(10px, -28px, 0);
    transform: translate3d(10px, -28px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -webkit-transform: translate3d(10px, -28px, 0);
    -moz-transform: translate3d(10px, -28px, 0);
    transform: translate3d(10px, -28px, 0);
    width: 18px;
  }
}

@-webkit-keyframes starMove2-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -webkit-transform: translate3d(-28px, -15px, 0);
    transform: translate3d(-28px, -15px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -webkit-transform: translate3d(-28px, -15px, 0);
    transform: translate3d(-28px, -15px, 0);
    width: 18px;
  }
}

@-moz-keyframes starMove2-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -moz-transform: translate3d(-28px, -15px, 0);
    transform: translate3d(-28px, -15px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -moz-transform: translate3d(-28px, -15px, 0);
    transform: translate3d(-28px, -15px, 0);
    width: 18px;
  }
}

@-o-keyframes starMove2-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    transform: translate3d(-28px, -15px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    transform: translate3d(-28px, -15px, 0);
    width: 18px;
  }
}

@keyframes starMove2-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -webkit-transform: translate3d(-28px, -15px, 0);
    -moz-transform: translate3d(-28px, -15px, 0);
    transform: translate3d(-28px, -15px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -webkit-transform: translate3d(-28px, -15px, 0);
    -moz-transform: translate3d(-28px, -15px, 0);
    transform: translate3d(-28px, -15px, 0);
    width: 18px;
  }
}

@-webkit-keyframes starMove3-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 14px;
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 14px;
  }

  40% {
    height: 14px;
    opacity: 0.1;
    -webkit-transform: translate3d(24px, -15px, 0);
    transform: translate3d(24px, -15px, 0);
    width: 14px;
  }

  to {
    height: 14px;
    opacity: 0;
    -webkit-transform: translate3d(24px, -15px, 0);
    transform: translate3d(24px, -15px, 0);
    width: 14px;
  }
}

@-moz-keyframes starMove3-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 14px;
    opacity: 1;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 14px;
  }

  40% {
    height: 14px;
    opacity: 0.1;
    -moz-transform: translate3d(24px, -15px, 0);
    transform: translate3d(24px, -15px, 0);
    width: 14px;
  }

  to {
    height: 14px;
    opacity: 0;
    -moz-transform: translate3d(24px, -15px, 0);
    transform: translate3d(24px, -15px, 0);
    width: 14px;
  }
}

@-o-keyframes starMove3-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 14px;
    opacity: 1;
    transform: translateZ(0);
    width: 14px;
  }

  40% {
    height: 14px;
    opacity: 0.1;
    transform: translate3d(24px, -15px, 0);
    width: 14px;
  }

  to {
    height: 14px;
    opacity: 0;
    transform: translate3d(24px, -15px, 0);
    width: 14px;
  }
}

@keyframes starMove3-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 14px;
    opacity: 1;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 14px;
  }

  40% {
    height: 14px;
    opacity: 0.1;
    -webkit-transform: translate3d(24px, -15px, 0);
    -moz-transform: translate3d(24px, -15px, 0);
    transform: translate3d(24px, -15px, 0);
    width: 14px;
  }

  to {
    height: 14px;
    opacity: 0;
    -webkit-transform: translate3d(24px, -15px, 0);
    -moz-transform: translate3d(24px, -15px, 0);
    transform: translate3d(24px, -15px, 0);
    width: 14px;
  }
}

@-webkit-keyframes starMove4-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -webkit-transform: translate3d(-17px, 24px, 0);
    transform: translate3d(-17px, 24px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -webkit-transform: translate3d(-17px, 24px, 0);
    transform: translate3d(-17px, 24px, 0);
    width: 18px;
  }
}

@-moz-keyframes starMove4-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -moz-transform: translate3d(-17px, 24px, 0);
    transform: translate3d(-17px, 24px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -moz-transform: translate3d(-17px, 24px, 0);
    transform: translate3d(-17px, 24px, 0);
    width: 18px;
  }
}

@-o-keyframes starMove4-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    transform: translate3d(-17px, 24px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    transform: translate3d(-17px, 24px, 0);
    width: 18px;
  }
}

@keyframes starMove4-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 18px;
    opacity: 0.1;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 18px;
  }

  40% {
    height: 18px;
    opacity: 1;
    -webkit-transform: translate3d(-17px, 24px, 0);
    -moz-transform: translate3d(-17px, 24px, 0);
    transform: translate3d(-17px, 24px, 0);
    width: 18px;
  }

  to {
    height: 18px;
    opacity: 0;
    -webkit-transform: translate3d(-17px, 24px, 0);
    -moz-transform: translate3d(-17px, 24px, 0);
    transform: translate3d(-17px, 24px, 0);
    width: 18px;
  }
}

@-webkit-keyframes starMove5-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 16px;
    opacity: 0.1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    width: 16px;
  }

  40% {
    height: 16px;
    opacity: 1;
    -webkit-transform: translate3d(20px, 20px, 0);
    transform: translate3d(20px, 20px, 0);
    width: 16px;
  }

  to {
    height: 16px;
    opacity: 0;
    -webkit-transform: translate3d(20px, 20px, 0);
    transform: translate3d(20px, 20px, 0);
    width: 16px;
  }
}

@-moz-keyframes starMove5-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 16px;
    opacity: 0.1;
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 16px;
  }

  40% {
    height: 16px;
    opacity: 1;
    -moz-transform: translate3d(20px, 20px, 0);
    transform: translate3d(20px, 20px, 0);
    width: 16px;
  }

  to {
    height: 16px;
    opacity: 0;
    -moz-transform: translate3d(20px, 20px, 0);
    transform: translate3d(20px, 20px, 0);
    width: 16px;
  }
}

@-o-keyframes starMove5-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 16px;
    opacity: 0.1;
    transform: translateZ(0);
    width: 16px;
  }

  40% {
    height: 16px;
    opacity: 1;
    transform: translate3d(20px, 20px, 0);
    width: 16px;
  }

  to {
    height: 16px;
    opacity: 0;
    transform: translate3d(20px, 20px, 0);
    width: 16px;
  }
}

@keyframes starMove5-49a297e6 {
  0% {
    height: 0;
    opacity: 0;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 0;
  }

  2% {
    height: 16px;
    opacity: 0.1;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    transform: translateZ(0);
    width: 16px;
  }

  40% {
    height: 16px;
    opacity: 1;
    -webkit-transform: translate3d(20px, 20px, 0);
    -moz-transform: translate3d(20px, 20px, 0);
    transform: translate3d(20px, 20px, 0);
    width: 16px;
  }

  to {
    height: 16px;
    opacity: 0;
    -webkit-transform: translate3d(20px, 20px, 0);
    -moz-transform: translate3d(20px, 20px, 0);
    transform: translate3d(20px, 20px, 0);
    width: 16px;
  }
}
</style>
